import React from 'react';
import { theme } from '../../data';
import { Card } from '../../types';
import { fmtDate } from '../../utils';
import ValueBadges from '../../valueBadges';
import {
  Magnet,
  OvCard,
  OvcBadges,
  OvcDate,
  OvcDraftTag,
  OvcFooter,
  OvcLbl,
  OvcQ,
  OvcStarHalf,
  OvcStars,
  OvcStarWrap,
  OvcWbTag,
  Pen,
} from './styles';

interface OverviewCardProps {
  card: Card;
  variant: 'front' | 'behind';
  style?: React.CSSProperties;
  onClick: () => void;
}

const OverviewCard = React.forwardRef<HTMLDivElement, OverviewCardProps>(
  ({ card, variant, style, onClick }, ref) => {
    const th = theme(card.from);
    const draft = !card.finalized;
    const noteCount = card.notes.length;

    return (
      <OvCard
        ref={ref}
        $bg={th.color}
        $variant={variant}
        style={style}
        onClick={onClick}
      >
        {draft && <OvcDraftTag>ENTWURF</OvcDraftTag>}
        <Magnet $color={th.color} $accent={th.accent} />
        <OvcLbl>Frage</OvcLbl>
        <OvcQ>{card.q}</OvcQ>
        {draft ? (
          <OvcWbTag>
            <Pen>✎</Pen> In Arbeit · {noteCount} Notiz
            {noteCount !== 1 ? 'en' : ''}
          </OvcWbTag>
        ) : (
          <OvcStars>
            {[1, 2, 3, 4, 5].map(i => {
              const n = card.rating || 0;
              const full = n >= i;
              const half = !full && n >= i - 0.5;
              return (
                <OvcStarWrap key={i}>
                  ☆
                  {(full || half) && (
                    <OvcStarHalf style={half ? undefined : { width: '100%' }}>
                      ★
                    </OvcStarHalf>
                  )}
                </OvcStarWrap>
              );
            })}
          </OvcStars>
        )}
        <OvcFooter>
          <OvcBadges>
            <ValueBadges values={card.values} fontSize={13} />
          </OvcBadges>
          <OvcDate>{fmtDate(card.createdAt)}</OvcDate>
        </OvcFooter>
      </OvCard>
    );
  },
);

OverviewCard.displayName = 'OverviewCard';

export default OverviewCard;
